import type { TableRowProps } from '@chakra-ui/react'
import { forwardRef, Tr } from '@chakra-ui/react'
import { isArray } from '@chakra-ui/utils'
import { cloneElement, isValidElement, useState } from 'react'
import type { ReactElement, ReactNode } from 'react'

export interface DashboardTableRowProps extends TableRowProps {
  children?: ReactNode
  hoverEffect?: boolean
}

export const TableRow = forwardRef(
  ({ children, sx, hoverEffect = true, ...rest }: DashboardTableRowProps, ref) => {
    const [isHovering, setIsHovering] = useState(false)
    const [clientY, setClientY] = useState(0)
    const [clientX, setClientX] = useState(0)

    const childArray = (isArray(children) ? children : [children]).filter(isValidElement) as ReactElement<any>[]

    return (
      <Tr
        ref={ref}
        sx={{ bgColor: hoverEffect && isHovering ? 'gray.50' : 'unset', ...sx }}
        onMouseEnter={(e) => {
          setIsHovering(true)
          rest.onMouseEnter?.(e)
        }}
        onMouseLeave={(e) => {
          setIsHovering(false)
          rest.onMouseLeave?.(e)
        }}
        {...rest}
        onClick={(e) => {
          // e.preventDefault()
          rest.onClick?.(e)
        }}
        onMouseDown={(e) => {
          setClientY(e.clientY)
          setClientX(e.clientX)
          rest.onMouseDown?.(e)
        }}
        onMouseUp={(e) => {
          e.preventDefault()
          const element = e.nativeEvent.target as HTMLElement

          if (
            element?.tagName === 'BUTTON' ||
            element?.tagName === 'A' ||
            element?.tagName === 'INPUT' ||
            element?.tagName === 'SELECT' ||
            element?.tagName === 'TEXTAREA'
          ) {
            return
          }

          if (clientY === e.clientY && clientX === e.clientX) {
            rest.onClick?.(e)
          }
        }}
      >
        {childArray.map((child, index) =>
          cloneElement(child, {
            key: index,
            sx: { background: hoverEffect && isHovering ? 'gray.50' : 'unset' },
          })
        )}
      </Tr>
    )
  },
)
